import React, { useState } from 'react';
import { TextBoxLayoutStyle, ZipCodeBox } from '@apply/components';
import { sectionHeaderStyle } from '../constants/styles';

export const ZipCodeBoxPanel: React.FC = () => {
    const [zipCode, set_zipCode] = useState('');

    return (
        <>
            <h6 style={sectionHeaderStyle}>Zip Code Components:</h6>
            <div style={{ marginBottom: '1rem' }}>
                <ZipCodeBox
                    id='zipCode'
                    value={zipCode}
                    onChange={set_zipCode}
                    label='Zip Code'
                    placeholder='01234'
                    required={true}
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <ZipCodeBox
                    id='zipCode'
                    value={zipCode}
                    onChange={set_zipCode}
                    label='Zip Code'
                    placeholder='01234'
                    required={true}
                    showInfoIcon={true}
                    infoText='Zip Code Entry'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <ZipCodeBox
                    id='zipCode'
                    value={zipCode}
                    onChange={set_zipCode}
                    label='Zip Code (Horiz.)'
                    placeholder='01234'
                    required={true}
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    labelWidth='120px'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <ZipCodeBox
                    id='zipCode'
                    value={zipCode}
                    onChange={set_zipCode}
                    label='Zip Code (Horiz.)'
                    placeholder='01234'
                    required={true}
                    showInfoIcon={true}
                    infoText='Zip Code Entry'
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    labelWidth='150px'
                />
            </div>
        </>
    );
};
